<template>
  <div
    :class="[
      'flex flex-wrap initial:gap-2',
      {
        'flex-col': column,
        'items-center': (column && position === 'center') || !column,
        'items-start': column && position === 'left',
        'items-end': column && position === 'right',
        'justify-center': !column && position === 'center',
        'justify-start': !column && position === 'left',
        'justify-end': !column && position === 'right',
      },
    ]"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
  export interface MActionListProps {
    column?: boolean;
    position?: 'left' | 'right' | 'center';
  }
  withDefaults(defineProps<MActionListProps>(), {
    column: false,
    position: 'right',
  });
</script>
